import React, { useContext, useEffect, useState } from "react";
import "../../../assets/AdminCss/admin_roles.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Link } from "react-router-dom";
import { base_url } from "./AdminUsers";
import axios from "axios";
// import { data } from "jquery";
import { AuthContext } from "../../../context/Authcontext";
import api from "../../../utils/api";
const AdminRoles = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [roles, setRoles] = useState([]);
  const [permit, setPermit]= useState([]);
  const { getRoles }= useContext(AuthContext);
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    try {
      const response = await axios.post(base_url+
      "/api/webapi/admin/Rolelist",{},
        {
          headers: {
            "content-type": "application/json",
            Authorization: `${auth}`,
          },
        }
      );
      if (!response.data.status) {
        throw new Error("failed to fetch users");
      }
      const role = response.data.data;
      setRoles(role);
    } catch (error) {
      console.log("err", error);
    }
  };




  const fetch= async()=> {
    const auth= localStorage.getItem('admin');
    const role= localStorage.getItem('role');

    try{

      const roles= await getRoles(auth, role);

      roles.map((roll)=>{
        const arr= Object.values(roll);

        arr.map((role)=>{

          role.map((mapp)=>{
            const asn= Object.keys(mapp);

            if(asn.includes('roles')){
              const vall= Object.values(mapp);

              vall.map((per)=>{
                setPermit(per);
              })

            }
          })
        })

    })

    }catch(err){
      console.log('err',err);
    }
  }

  // console.log('perr',permit);

  useEffect(()=>{
    fetchRoles();
    fetch();
  },[])

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="wrapper">
        {/* Main Sidebar */}
        {/* <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        /> */}
        
        {/* Header - Pass mobile info */}
        {/* <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        /> */}
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Roles
          </h1>
          <div className="pull-right topright_buttons">
            {" "}
            <Link
              to="/admin/add_roles"
              className="btn btn-success btn-add-new red_btn"
              style={{display: permit.includes('Add Roles') ? 'block' : 'none'}}
            >
              <i className="fa fa-plus"></i> <span>Add New</span>
            </Link>
          </div>
          <div id="sidebar-mini-notifications"></div>
          <div className="page-content mt-4 browse">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3">
                  <div className="panel-body">
                    {/* <form method="get" className="form-search">
                                            <div id="search-input">

                                                <div className="input-group col-md-12">
                                                    <input type="text" className="form-control" id="myInput"
                                                         placeholder="Search" name="s" value=""
                                                         fdprocessedid="ge7qwp"/>
                                                    <span className="input-group-btn">
                                                        <button className="btn btn-info btn-lg" type="submit"
                                                            fdprocessedid="da396e">
                                                            <i className="sidebar-mini-search"></i>
                                                        </button>
                                                    </span>
                                                </div>
                                            </div>
                                        </form> */}
                    <div className="mt-3">
                      <table id="dataTable" className="table table-hover">
                        <thead>
                          <tr>
                            <th className="text-center">Name</th>
                            <th className="text-center">Display Name</th>
                            <th className="text-center" style={{display: permit.includes('Edit Role') ? 'block' : 'none'}}>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {roles?.map((roleObj, roleIndex) => {
                            return (
                              <tr key={roleIndex} className="text-center">
                                <td>{Object.keys(roleObj)}</td>
                                <td>{Object.keys(roleObj)}</td>
                                <td className="btn btn-primary" style={{display: permit.includes('Edit Role') ? 'block' : 'none'}}>
                                  <Link
                                    to='/admin/add_roles'
                                    state={{roleObj}}                                    
                                  >
                                    Edit
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminRoles;
